<template>
    <button
        v-tippy="t('editorInsertImage')"
        :class="[buttonState(true), 'flex-none rounded p-1 text-sm']"
        @mousedown.prevent="openImageInsertModal"
    >
        <MdiImage class="h-6 w-6" />
    </button>
</template>
<script setup>
import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
import MdiImage from 'materialdesignicons-vue3/icons/MdiImage.js';

defineExpose({
    name: 'ImageButton',
});

const props = defineProps({
    imageInsertModal: {
        type: Object,
        required: true,
    },
});

const imageInsertModal = props.imageInsertModal;

const openImageInsertModal = () => {
    imageInsertModal.state.open = true;
};
</script>
